import { FormatConstants } from "services/keyConstants";
import { workEnvironmentGetArea } from "api/module/workEnvironment";

export const getDynamicStatusTypes = async (defaultName) => {
  const dynamicAreaRecordTypes = [
    FormatConstants.WORKENVIRONMENT.TEMPERATURE_HUMIDITY_REGISTER,
    FormatConstants.WORKENVIRONMENT.PEST_CONTROL_RECORD,
    FormatConstants.WORKENVIRONMENT.FUMIGATION_RECORD,
    FormatConstants.WORKENVIRONMENT.CLEANING_REGISTER,
    FormatConstants.WORKENVIRONMENT.APRON_SLIPPER_CLEANING_RECORD,
    FormatConstants.WORKENVIRONMENT.PERSONAL_HYGIENE_RECORD,
    FormatConstants.WORKENVIRONMENT.ESD_CONTROL_LOG,
  ];

  if (dynamicAreaRecordTypes.includes(defaultName)) {
    const { data: fetchedAreas = {} } = workEnvironmentGetArea();

    const areas = fetchedAreas || {};

    const areaList = areas[defaultName] || [];
    const areaOptions = [...new Set(areaList.map((area) => area.trim()))].map(
      (area) => ({ label: area, value: area })
    );

    return { areaOptions };
  }

  let areaOptions = [
    { label: "General Area", value: "General Area" },
    { label: "Storage", value: "Storage" },
    { label: "Production", value: "Production" },
  ];

  return { areaOptions };
};
